export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.249 2.973a.75.75 0 01-.708.79 8.25 8.25 0 108.697 8.696.75.75 0 111.497.082c-.28 5.133-4.532 9.209-9.735 9.209-5.385 0-9.75-4.365-9.75-9.75 0-5.203 4.076-9.454 9.209-9.735a.75.75 0 01.79.708zm2.044.29a.75.75 0 01.957-.458 9.775 9.775 0 015.958 5.982.75.75 0 11-1.416.495 8.275 8.275 0 00-5.042-5.063.75.75 0 01-.457-.957z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.53 7.47a.75.75 0 010 1.06l-.78.78v1.38l.56.56h1.38l.78-.78a.75.75 0 111.06 1.06l-1 1a.75.75 0 01-.53.22h-2.69l-3.78 3.78a.75.75 0 01-1.06-1.06l3.78-3.78V9a.75.75 0 01.22-.53l1-1a.75.75 0 011.06 0z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};